import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	accordion: {
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: "9px",
		overflow: "hidden",
		"&:before": {
			display: "none"
		},
		"&.Mui-expanded": {
			margin: 0
		}
	},
	accordionSummary: {
		"&:hover": {
			backgroundColor: colors.purple[50]
		}
	},
	accordionSummaryContent: {
		display: "flex",
		flexDirection: "column",
		gap: "2px"
	},
	macroLabel: {
		fontWeight: 700,
		fontSize: "14px",
		color: colors.gray[900]
	},
	macroSubLabel: {
		fontSize: "11px",
		color: colors.gray[400]
	},
	countPill: {
		fontSize: "11px",
		fontWeight: 500,
		color: colors.gray[600],
		backgroundColor: colors.gray[50],
		borderRadius: "20px",
		padding: "4px 9px",
		whiteSpace: "nowrap"
	},
	accordionDetails: {
		borderTop: `1px solid ${colors.gray[100]}`,
		padding: "6px 18px 16px",
		display: "flex",
		flexDirection: "column",
		gap: "6px"
	}
}))

export default useStyles
